import useSWR from 'swr';

import { SWR_GLOBAL_CONFIG } from '~/api/_constant';
import { request } from '~/api/_utils/request';

const getPath = (uid: string | number) => `/v2/organizations/${uid}/presentations`;

export async function apiGetV2OrganizationByIdPresentations(uid: string | number) {
  const response = await request.GET<{ presentations: ApiV2PresentationSimple[] }>(getPath(uid));
  return response.presentations;
}

export function useSWRV2OrganizationByIdPresentations(uid: string | number) {
  const swr = useSWR(
    getPath(uid),
    () => apiGetV2OrganizationByIdPresentations(uid),
    SWR_GLOBAL_CONFIG,
  );
  return { ...swr, presentations: swr.data };
}

/** railsの`app/serializers/v2/presentation_serializers/simple.rb`に該当 */
export type ApiV2PresentationSimple = {
  id: number;
  video: string;
  title: string;
  thumbnail: string;
  votes: number;
  competition_presentations: CompetitionPresentation[];
};

type CompetitionPresentation = {
  id: number;
  is_most_voted: boolean;
  competition: Competition;
};

type Competition = {
  id: number;
  title: string;
  corporate: Corporate;
};

type Corporate = {
  id: number;
  name: string;
  uid: string;
  category: string;
  category_postfix?: boolean;
};
